<template>
  <div>
    <h1 class="page-header">{{ $t('mainProgram.pageTitle') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
              >
                <p class="ts-text-gray-500">
                  <b
                    ><i
                      ><span class="text-danger">* </span
                      >{{ $t('mainProgram.note') }}:
                    </i></b
                  >
                  {{ $t('mainProgram.onlyuseratheadofficecanmodifyordelete') }}
                </p>
              </div>
              <div
                class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end"
              >
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 300px"
                  class="kh-font"
                />
              </div>
            </div>
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-loading-banner :loading="exporting">
              <Table
                :columns="columns"
                :data="resources"
                :loading="loading"
                max-height="700"
                stripe
                highlight-row
                size="small"
              >
                <template slot-scope="{ row }" slot="is_enable_moeys_id">
                  <span v-if="row.is_enable_moeys_id"
                    ><i class="far fa-check-square text-primary"></i
                  ></span>
                  <span v-else
                    ><i class="far fa-window-close text-danger"></i
                  ></span>
                </template>
                <template slot-scope="{ row }" slot="action">
                  <a
                    href="#"
                    title="edit"
                    class="text-primary mr-2"
                    @click.prevent="edit(row)"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <a
                    href="#"
                    title="delete"
                    class="text-danger"
                    @click.prevent="destroy(row.acp_id)"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </template>
              </Table>
            </ts-loading-banner>
          </div>
          <div class="d-flex justify-content-between align-items-center p-15">
            <ts-total-list v-model="pagination" />
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'main-program',
  props: ['editData'],
  data () {
    return {
      edit_data: this.editData,
      loading: false,
      waiting: false,
      exporting: false
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('mainProgram', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.mainProgram.search
      },
      set (newVal) {
        this.$store.commit('mainProgram/SET_SEARCH', newVal)
        this.$store.commit('mainProgram/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          title: this.$t('mainProgram.nameKh'),
          key: 'acp_name_native',
          minWidth: 80
        },
        {
          title: this.$t('mainProgram.nameEn'),
          minWidth: 80,
          key: 'acp_name_foreign'
        },
        {
          title: this.$t('mainProgram.abbreviation'),
          key: 'acp_abbr',
          minWidth: 80
        },
        {
          title: this.$t('mainProgram.moeysid'),
          slot: 'is_enable_moeys_id',
          minWidth: 80,
          align: 'center',

        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 120
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true

      this.$store
        .dispatch('mainProgram/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit (data) {
      this.edit_data = data
      this.$router.push(`/main-programs/${data.acp_id}`)
    },

    async destroy (id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('mainProgram/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'main-program-create') {
      this.$store.commit('mainProgram/RESET_STATE')
    }
    next()
  }
}
</script>
